import React, { useEffect, useState } from 'react';
import api from '../../api';
import AdminLayout from './AdminLayout';
import { Card } from '../ui/card';
import { format } from 'date-fns';

const methodBadge = {
  razorpay: 'bg-accent/15 text-primary',
  mock: 'bg-muted text-muted-foreground',
};

export default function AdminTransactions() {
  const [txs, setTxs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get('/api/admin/transactions');
        setTxs(data || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const total = txs.filter((t) => t.status === 'success').reduce((s, t) => s + (t.amount || 0), 0);

  return (
    <AdminLayout>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Transactions</h1>
          <p className="text-muted-foreground text-sm">FASTag recharges via Razorpay</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-muted-foreground uppercase">Total recharged</p>
          <p className="text-2xl font-bold text-green-600">₹{total}</p>
        </div>
      </div>

      <Card className="overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-muted-foreground">Loading…</div>
        ) : txs.length === 0 ? (
          <div className="p-8 text-center text-muted-foreground">No transactions yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-background text-left">
              <tr>
                <th className="px-4 py-3 font-semibold">Tx ID</th>
                <th className="px-4 py-3 font-semibold">User</th>
                <th className="px-4 py-3 font-semibold">Vehicle</th>
                <th className="px-4 py-3 font-semibold">Amount</th>
                <th className="px-4 py-3 font-semibold">Method</th>
                <th className="px-4 py-3 font-semibold">Payment ID</th>
                <th className="px-4 py-3 font-semibold">Status</th>
                <th className="px-4 py-3 font-semibold">Date</th>
              </tr>
            </thead>
            <tbody>
              {txs.map((t) => (
                <tr key={t.id} className="border-t border-border">
                  <td className="px-4 py-3 font-mono text-xs">{t.id.slice(0, 8)}</td>
                  <td className="px-4 py-3">{t.user_phone || '—'}</td>
                  <td className="px-4 py-3 font-mono">{t.vehicle_number}</td>
                  <td className="px-4 py-3 font-semibold">₹{t.amount}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${methodBadge[t.method] || 'bg-muted text-foreground'}`}>
                      {t.method || 'razorpay'}
                    </span>
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{t.razorpay_payment_id || '—'}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      t.status === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {t.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">
                    {t.created_at ? format(new Date(t.created_at), 'MMM dd HH:mm') : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </AdminLayout>
  );
}
